
import utils from '../libs/utils';
import axios from './axios';

export default {

  // 门店积分查询（列表返回）
  // http://api.fe.linkdoc.com/project/1204/interface/api/35664
  storePointList(params) {
    return axios.get(`v1/erp-business-web/integal/account/list?${utils.exchangeParams(params)}`);
  },

  // 积分申请列表查询
  // http://api.fe.linkdoc.com/project/1204/interface/api/35671
  storeApplyPointList(params) {
    return axios.get(`v1/erp-business-web/integal/exchange/list?${utils.exchangeParams(params)}`);
  },

  // 门店积分查询（单条返回）
  // http://api.fe.linkdoc.com/project/1204/interface/api/35720
  storePoint(params) {
    return axios.get(`v1/erp-business-web/integal/account/find?${utils.exchangeParams(params)}`);
  },

  // 积分账户明细查询
  // http://api.fe.linkdoc.com/project/1204/interface/api/35699
  accountDetail(params) {
    return axios.get(`v1/erp-business-web/integal/account/detail?${utils.exchangeParams(params)}`);
  },

  // 积分申请单详细信息
  // http://api.fe.linkdoc.com/project/1204/interface/api/35678
  pointApplyDetailInfo(params) {
    return axios.get(`v1/erp-business-web/integal/exchange/info?${utils.exchangeParams(params)}`);
  },

  // 申请单明细列表查询
  // http://api.fe.linkdoc.com/project/1204/interface/api/35685
  pointApplyDetailList(params) {
    return axios.get(`v1/erp-business-web/integal/exchange/detail/list?${utils.exchangeParams(params)}`);
  },

  // 积分申请单上传签收单
  // http://api.fe.linkdoc.com/project/1204/interface/api/35692
  uploadReceipt(params) {
    return axios.post('v1/erp-business-web/integal/exchange/uploadReceiptPics', utils.exchangeParams(params));
  },

  // 积分申请单提交
  // http://api.fe.linkdoc.com/project/1204/interface/api/35734
  pointApplySubmit(params) {
    return axios.post('v1/erp-business-web/integal/exchange/submit', utils.exchangeParams(params));
  },
};
